import { CallAPI } from "../../apiManager/ApiCall";
import {
  examSimulatorSessionURL,
  examSimulatorURL,
} from "../../apiManager/APIConfig";

export const GetExamSimulatorQuestionsCall = async (params = {}) => {
  try {
    const qs = new URLSearchParams();
    if (params.category) qs.set("category", params.category);
    if (params.slide_id) qs.set("slide_id", params.slide_id);
    if (params.active_only) qs.set("active_only", "true");
    const q = qs.toString();
    return await CallAPI({
      url: `${examSimulatorURL}${q ? `?${q}` : ""}`,
      method: "GET",
    });
  } catch (error) {
    return { status: 400, message: "Failed to load exam simulator questions" };
  }
};

export const CreateExamSimulatorQuestionCall = async (body) => {
  try {
    return await CallAPI({
      url: examSimulatorURL,
      method: "POST",
      body,
    });
  } catch (error) {
    return { status: 400, message: "Failed to create question" };
  }
};

export const UpdateExamSimulatorQuestionCall = async (id, body) => {
  try {
    return await CallAPI({
      url: `${examSimulatorURL}/${id}`,
      method: "PUT",
      body,
    });
  } catch (error) {
    return { status: 400, message: "Failed to update question" };
  }
};

export const DeleteExamSimulatorQuestionCall = async (id) => {
  try {
    return await CallAPI({
      url: `${examSimulatorURL}/${id}`,
      method: "DELETE",
    });
  } catch (error) {
    return { status: 400, message: "Failed to delete question" };
  }
};

export const GetExamSimulatorSessionCall = async (category) => {
  try {
    return await CallAPI({
      url: `${examSimulatorSessionURL}?category=${encodeURIComponent(category)}`,
      method: "GET",
    });
  } catch (error) {
    return { status: 400, message: "Failed to start exam session" };
  }
};
